var map = {
	"./Feature-1.svg": 1232,
	"./Feature-2.svg": 1233,
	"./Feature-3.svg": 1234,
	"./Feature-4.svg": 1235,
	"./Feature-5.svg": 1236,
	"./Feature-6.svg": 1237,
	"./Feature-7.svg": 1238,
	"./Feature-8.svg": 1239,
	"./Step1-m.svg": 1216,
	"./Step1.svg": 1217,
	"./Step2-m.svg": 1150,
	"./Step2.svg": 1151,
	"./Step3.svg": 1152,
	"./advancedSecurity.svg": 1240,
	"./backup.svg": 1241,
	"./easyBuy.svg": 1242,
	"./easyUse.svg": 1243,
	"./externalServer.svg": 1244,
	"./focus.svg": 1245,
	"./hosting.svg": 1246,
	"./hourlyServer.svg": 1218,
	"./iranServer.svg": 1247,
	"./liveMigration.svg": 1248,
	"./noLimit.svg": 1249,
	"./reliability.svg": 1250,
	"./siem.svg": 1251,
	"./startupLoad.svg": 1252,
	"./test.svg": 1253,
	"./virtual-server.svg": 1014,
	"./virtualDesktop.svg": 1254,
	"./virtualOrganization.svg": 1255
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1146;